import BackButton from "components/Button/BackButton"
import DeleteButton from "components/Button/DeleteButton"
import SaveButton from "components/Button/SaveButton"
import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { EmptyString, FormTypeAdd, FormTypeEdit, StatusCodeActive, StatusCodeDelete } from "utils/Constant"
import { CheckUndefined, GetStatus, removeNonNumeric } from "utils/helpers"
import UnDeleteButton from "components/Button/UnDeleteButton"
import Select from 'react-select'
import { useModal } from "utils/context/ModalContext"
import { useCallApi } from "api/apiHooks"
import { FormCard, MainBodyCard, PagesFormTitle } from "components/Cards"

export default function BeneficiaryAccountForm(){
    const navigate = useNavigate()
    const { showFail, showLoading, hideLoading, showSuccess, confirm } = useModal()
    const { fetchBankList, fetchDeleteBeneficiary, fetchBeneficiaryAccountById, fetchInsertBeneficiaryAccount, fetchUpdateBeneficiaryAccount} = useCallApi()

    let queryString = new URLSearchParams(window.location.search)
    let formType = queryString.get("formType")
    let paramBeneficiaryId = queryString.get("beneficiaryId")

    const [bankId, setBankId] = useState(EmptyString)
    const [bankOptions, setBankOptions] = useState([])
    const [accountNo, setAccountNo] = useState(EmptyString)
    const [accountName, setAccountName] = useState(EmptyString)
    const [status, setStatus] = useState(EmptyString)
    const [createDate, setCreateDate] = useState(EmptyString)
    const [updateDate, setUpdateDate] = useState(EmptyString)
    const [updateBy, setUpdateBy] = useState(EmptyString)

    const saveBtnClick = async () => {
        if (validateForm()){
            const isConfirmed = await confirm()

            if (isConfirmed) {
                showLoading()

                try{
                    if (formType === FormTypeAdd){
                        const res = await fetchInsertBeneficiaryAccount(accountName, accountNo, bankId.value)
                        
                        if (!res) return

                        showSuccess({
                            onSuccess: () => {
                                navigate('/beneficiary-account')
                            }
                        })
                    }else{
                        const res = await fetchUpdateBeneficiaryAccount(paramBeneficiaryId, accountName, accountNo, bankId.value)
                        
                        if (!res) return

                        showSuccess({
                            onSuccess: () => {
                                navigate('/beneficiary-account')
                            }
                        })
                    }   
                } finally {
                    hideLoading()
                }
            }
        }
    }
    const deleteBtnClick = async () => {
        if (validateForm()){
            const isConfirmed = await confirm()

            if (isConfirmed) {
                showLoading()

                try {
                    const res = await fetchDeleteBeneficiary(paramBeneficiaryId, status)
                        
                    if (!res) return

                    showSuccess({
                        onSuccess: () => {
                            navigate('/beneficiary-account')
                        }
                    })
                } finally {
                    hideLoading()
                }
            }
        }
    }
    const backBtnClick = () => {
        navigate(-1)
    }

    function validateForm(){
        if (bankId === null || !CheckUndefined(bankId)) {
            showFail('Bank must be selected!')
            return false
        }

        if (accountName === '') {
            showFail('Account Name is required!')
            return false
        }

        if (accountNo === '') {
            showFail('Account No is required!')
            return false
        }

        return true
    }

    useEffect(() => {
        const firstLoad = async () => {
            showLoading()

            try {
                const res = await fetchBankList('', '', '1', 10000, 0)
                        
                if (!res) return

                let data = res.data.listData
                let tempArray = []

                tempArray.push({ label: "Select Bank", value: "0" })

                for (let i = 0; i < data.length; i++){
                    tempArray.push({ label: data[i].bankCode.toUpperCase() + " - " + data[i].bankName.toUpperCase(), value: String(data[i].bankId) })
                }

                setBankOptions(tempArray)
                setBankId(tempArray[0].value)

                if (formType === FormTypeEdit){
                    const res = await fetchBeneficiaryAccountById(paramBeneficiaryId)
                    
                    if (!res) return

                    let data = res.data

                    setBankId({label: data.bankCode.toUpperCase() + " - " + data.bankName.toUpperCase(), value: String(data.bankId)})
                    setAccountName(data.accountName)
                    setAccountNo(data.accountNo)
                    setStatus(data.status)
                    setCreateDate(data.createDate)
                    setUpdateDate(data.updateDate)
                    setUpdateBy(data.updateBy)
                }
            } finally {
                hideLoading()
            }
        }

        firstLoad()
    }, [])

    return (
        <MainBodyCard>
            <PagesFormTitle
                title='Beneficiary Account Detail'
                formType={formType}
                status={status}
                createDate={createDate}
                updateBy={updateBy}
                updateDate={updateDate}
            />

            <div className="mt-5 flex flex-col gap-3">
                {/* Bank */}
                <FormCard title='Bank'>
                    <Select options={bankOptions} value={bankId} onChange={setBankId} />
                </FormCard>
                <FormCard title='Account Name'>
                    <input className="input" value={accountName} onChange={(e) => { setAccountName(e.target.value.toUpperCase()) }} />
                </FormCard>
                <FormCard title='Account No'>
                    <input 
                        className="input" 
                        value={accountNo}
                        onChange={(e) => { setAccountNo(removeNonNumeric(e.target.value)) }} 
                    />
                </FormCard>
            </div>
                
            <div className="mt-5 flex flex-wrap justify-end w-full gap-2">
                <SaveButton onClick={saveBtnClick} visible={true} />
                <DeleteButton onClick={deleteBtnClick} visible={ formType === FormTypeAdd ? false : (status === StatusCodeActive ? true : false) } />
                <UnDeleteButton onClick={deleteBtnClick} visible={formType === FormTypeEdit ? (status === StatusCodeDelete ? true : false) : false} />
                <BackButton onClick={backBtnClick}  />
            </div>
        </MainBodyCard>
    )
}